import { getSlotzAuthConfig } from 'helpers/MyAccountUtils';
import timedFetch from 'middleware/timedFetch';

const SLOTZ_CONSENT_BASE = '/mobileapi/accountapi/consent';

/**
 * The consent type for paid media audience targeting (Share/Sell scope).
 * This is the Tollhouse consent type ID used for the Privacy Preferences page.
 */
export const CONSENT_TYPE_SHARE_SELL = '2';

/** A single consent preference record from Tollhouse. */
export interface ConsentPreference {
  consentType: string;
  userAction: string | null;
  businessEntity: string;
  marketplace: string;
}

/** Payload to update consent via the POST endpoint. */
export interface ConsentUpdatePayload {
  consentType: string;
  userAction: string;
}

/**
 * Fetch the customer's current consent preferences from Tollhouse via Slotz.
 * Requires `consentType` query param (e.g., "SHARE_SELL").
 *
 * Response: List<ConsentPreference> — empty list means no record (opted in by default).
 */
export function getConsentPreferences(
  { url }: { url: string },
  consentType: string = CONSENT_TYPE_SHARE_SELL,
  fetcher = timedFetch('getConsentPreferences')
): Promise<Response> {
  const params = new URLSearchParams({ consentType });
  return fetcher(`${url}${SLOTZ_CONSENT_BASE}/preferences?${params.toString()}`, getSlotzAuthConfig());
}

/**
 * Write a consent preference change to Tollhouse via Slotz.
 * userAction: "REJECT" = opt out, "ACCEPT" = opt back in.
 */
export function updateConsentPreferences(
  { url }: { url: string },
  payload: ConsentUpdatePayload,
  fetcher = timedFetch('updateConsentPreferences')
): Promise<Response> {
  const authConfig = getSlotzAuthConfig();
  return fetcher(`${url}${SLOTZ_CONSENT_BASE}/update`, {
    ...authConfig,
    method: 'POST',
    headers: {
      ...authConfig.headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });
}
